import React, {useEffect, useState} from "react";
import {useHistory} from "react-router";
import Icon from "../icon/Icon";

// Reset di stile: lo step cliccabile era un Icon/<span> con onClick, ora e' un <button>.
// Il reset azzera sfondo, bordo, padding e font propri del button; display:flex e
// align-items:center riproducono la disposizione icona + testo del contenitore
// originale, cosi' la resa grafica resta identica.
const stileBottoneStep = {
    background: "none",
    border: "none",
    padding: 0,
    font: "inherit",
    color: "inherit",
    cursor: "pointer",
    display: "flex",
    alignItems: "center"
}

function StepBar(props) {

    const [stepBar, setStepBar] = useState([])
    const history = useHistory()

    useEffect(() => {
        createStepBar()
    },[props.steps,props.stepAttivo])

    function onClickStep(codiceStep){
        history.push({
            pathname: props.path ? props.path : "#",
            steps:history.location.steps?history.location.steps:[],
            stepAttivo:codiceStep
        })
    }

    function createStepBar(){
        let newStepBar = []
        if(props.steps.length > 0){
            props.steps.forEach(step => {
                const attivo = step.codiceStep === props.stepAttivo
                const icona = step.iconAttivo || step.iconDisattivato ?
                    <Icon height={"50px"} width={"50px"} alt={""}
                          path={attivo ? step.iconAttivo : step.iconDisattivato}
                          style={{marginRight: "10px", cursor: step.cliccabile ? "pointer" : "default"}}/> : null
                const testo = (
                    <span style={{color: attivo && (step.iconAttivo || step.iconDisattivato) ? "#1b7ea9" : "black", fontWeight:"bold",fontSize:"24px",cursor:step.cliccabile?"pointer":"default"}}>{step.nome}</span>
                )
                let newStep = (
                    <div key={step.codiceStep} className={props.col} style={{borderBottom:attivo ? "3px solid #1b7ea9" : "3px solid black", alignItems: "center", display: "flex", justifyContent: "center",opacity:attivo?"1":"0.5"}}>
                        {step.cliccabile ?
                            <button type="button"
                                    aria-current={attivo ? "step" : undefined}
                                    onClick={() => onClickStep(step.codiceStep)}
                                    style={stileBottoneStep}>
                                {icona}
                                {testo}
                            </button> :
                            <>
                                {icona}
                                {testo}
                            </>
                        }
                    </div>
                )
                newStepBar.push(newStep)
            })
            setStepBar(newStepBar)
        }
    }

    return (
        <div className={"row"} style={{height:"70px"}}>
            {stepBar}
        </div>
    )
}

export default StepBar
